export default __webpack_public_path__ + "static/media/logo-bank-bri.13c50876.png";